module.exports = __webpack_public_path__ + "static/media/wheelalign.1af83329.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/wheelalign.jpg
// module id = 754
// module chunks = 0